import {
    createLoadingSpinnerComponent,
} from '@vfde-brix/loading-spinner';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { LOADING_INDICATOR_CONTAINER } from 'Constant';

/**
 * LoadingSpinner BRIX component
 *
 */
export const mountLoadingSpinner = () => {

    const loadingSpinnerContainer = document.getElementById(LOADING_INDICATOR_CONTAINER);

    return createLoadingSpinnerComponent(loadingSpinnerContainer, {
        business: NO_PATTERN_BUSINESS_LOGIC,
    });

};
